import { AddressPlanType } from './types'

const propMap = {
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'short_name',
  locality: 'long_name',
  postal_code: 'short_name',
  street_number: 'short_name',
  route: 'short_name',
}

const storeAddressMap = {
  administrative_area_level_1: 'address_state',
  administrative_area_level_2: 'address_county',
  locality: 'address_city',
  postal_code: 'address_zip',
  street_number: 'address_street',
  route: 'address_street',
}

type Props = {
  place: AddressPlanType,
  onAnswerQuestion: (name: string, value: string) => void
}

export const savePlaceAnswers = ({
  place,
  onAnswerQuestion,
}: Props): void => {
  const storageMap = {}

  place.address_components.forEach(address => {
    const type = address.types[0]
    const propName = propMap[type]
    const storeAttr = storeAddressMap[type]

    if (propName && storeAttr) {
      let addressValue = address[propName]

      if (storeAttr === 'address_street' && type === 'route' && storageMap['address_street']) {
        addressValue = `${storageMap['address_street']} ${addressValue}`
      }
      storageMap[storeAttr] = addressValue
    }
  })

  onAnswerQuestion('address_street_full', place.formatted_address)
  Object.keys(storageMap).forEach(key => {
    onAnswerQuestion(key, storageMap[key])
  })
}
